export enum MKTimeMode {
    /**
     * Returns the Unix timestamp of the current playback time.
     * 
     * For live stream EXT-X-PROGRAM-DATE-TIME tags in HLS manifests are utilized for this value, if present.
     *
     * This is the default time mode for Live and Events.
     */
    AbsoluteTime = "absolutetime",

    /**
     * Returns the relative timestamp of the current playback time.
     * 
     * For live streams the beginning of the DVR window at the time of tuning in is defined as 0.
     *
     * This is the default time mode for VOD, Catchup and DVR.
     */
    RelativeTime = "relativetime"
}